import userItemConnector from "../user-item-connector"
import UserViewItem from "./UserViewItem"

export default userItemConnector(UserViewItem)
